import EmptyView1 from '../../layouts/EmptyView1'
import ResetPassword from './ResetPassword'

export default EmptyView1(ResetPassword)
